/**
 * The Founding Circle (Gordon 2026-11-02, his sister's idea): "we're not looking
 * for investors but angels for the cause of taking back the music business and
 * giving it to the music makers by building a solid platform". A small circle of
 * makers and friends backs the launch and early development, each by their
 * means. Shown on the Angels tab and the /launch slides.
 *
 * Add a person ONLY with their OK. Amounts are never shown. `uid` (their BB
 * account) gives them the Founding Circle badge next to their name — the list
 * lives here, not on the user doc, so nobody can give the badge to themselves.
 */
export const FOUNDING_CIRCLE: { name: string; uid?: string }[] = [];

/** Is this account one of the Founding Circle? (`list` is for tests.) */
export function isFoundingCircle(uid?: string | null, list: { uid?: string }[] = FOUNDING_CIRCLE): boolean {
  return !!uid && list.some(m => m.uid === uid);
}

/** Who the angels are — on a shared first place, all equally visible (Gordon
 *  2026-11-02). Keys under `foundingCircle.*`. */
export const FOUNDING_CIRCLE_GROUPS = ['groupMakers', 'groupPros', 'groupLovers'] as const;

/** What founding members get — keys under `foundingCircle.*`. */
// Gordon 2026-11-02: name on the platform, a vote, a board seat, first to try tools (the badge goes without saying).
export const FOUNDING_CIRCLE_PERKS = ['perkName', 'perkVote', 'perkBoard', 'perkFirst'] as const;

/** Join BB (a Dashboard tab) with the Founding Circle preselected; the tab scrolls to the form. */
export const FOUNDING_CIRCLE_JOIN = '/dashboard?tab=join&role=circle';

/** Where the badge leads: the Founding Circle on the Angels tab. */
export const FOUNDING_CIRCLE_PAGE = '/dashboard?tab=angels#founding-circle';
